import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZslBtnComponent } from './zsl-btn.component';

@NgModule({
  declarations: [ZslBtnComponent],
  imports: [
    CommonModule
  ],
  exports:[
    ZslBtnComponent
  ]
})
export class ZslBtnModule { }
